import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

const SPACING_NORMAL = 0.5;
const SPACING_MULTILINE = 0.1;

interface Props {
  label: string;
  display?: boolean;
  info?: string | React.ReactNode;
  multiLine?: boolean;
  color?: string;
  actions?: React.ReactNode;
}

export const InfoRow: React.FC<Props> = ({ label, info, multiLine, display = true, color, actions }) => {
  if (!display || info === undefined) {
    return null;
  }

  return (
    <Box mx={1}>
      {!multiLine && <Divider sx={{ margin: 0 }} />}

      <Stack
        paddingTop={multiLine ? SPACING_MULTILINE : SPACING_NORMAL}
        paddingBottom={SPACING_NORMAL}
        display="flex"
        justifyContent="space-between"
        direction={'row'}
        gap={1}
      >
        <Stack direction={'row'} justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
          {actions}
        </Stack>
        <Stack direction={'column'} spacing={SPACING_NORMAL}>
          {typeof info === 'string' ? (
            <Typography align="right" color={color}>
              {info ?? '-'}
            </Typography>
          ) : (
            <Box>{info}</Box>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
